module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point2_2-7e54d6808a916485cefd293d8372bd4e.jpg";